import { isHexColor } from '@salsita-ai/platform-common/utils';
import { memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { implementCustomExpressions } from '../__generated/implementation.js';
const DEFAULT_COLLECTION = {
    type: 'colors',
    key: 'default',
    name: 'Default'
};
const DEFAULT_DESIGN = {
    type: 'color',
    key: 'default',
    name: 'Default',
    defaultDrawstringColor: 'white'
};
// Keep the full drawstring color catalogue in the domain so the remaining
// colors can be made available again without restoring data or assets.
const AVAILABLE_DRAWSTRING_COLOR_KEYS = new Set([
    'black',
    'white'
]);
export const sidebarExpressions = implementCustomExpressions({
    PartsWithDesign: {
        $collectionMap: (self)=>self.$shorts.$collectionMap
    },
    Shorts: {
        $collectionMap: memoEval((self)=>[
                self.$collections
            ], (collections)=>{
            return Object.fromEntries(collections.map((c)=>[
                    c.key,
                    c.type === 'colors' ? {
                        type: 'colors',
                        key: c.key,
                        name: c.name,
                        thumbnailUrl: c.thumbnailUrl,
                        designs: Object.fromEntries(c.designs.map((design)=>[
                                design.key,
                                {
                                    type: 'color',
                                    ...design
                                }
                            ]))
                    } : {
                        type: 'textures',
                        key: c.key,
                        name: c.name,
                        thumbnailUrl: c.thumbnailUrl,
                        designs: Object.fromEntries(c.designs.map((design)=>[
                                design.key,
                                {
                                    type: 'texture',
                                    ...design
                                }
                            ]))
                    }
                ]));
        })
    },
    WithDesign: {
        $collectionOptions: memoEval((self)=>[
                self.$collectionMap
            ], (collectionMap)=>{
            return Object.values(collectionMap).map((c)=>({
                    label: c.name,
                    value: c.key,
                    img: c.thumbnailUrl
                }));
        }),
        $textureOptions: memoEval((self)=>[
                self.$collectionMap,
                self.collection
            ], (collectionMap, collectionKey)=>{
            const collection = collectionMap[collectionKey];
            if (collection?.type === 'textures') {
                return Object.values(collection.designs).map((design)=>({
                        label: design.name,
                        value: design.key,
                        img: design.thumbnailUrl
                    }));
            }
            return [];
        }),
        $colorSwatches: memoEval((self)=>[
                self.$collectionMap,
                self.collection
            ], (collectionMap, collectionKey)=>{
            const collection = collectionMap[collectionKey];
            if (collection?.type === 'colors') {
                return Object.fromEntries(Object.values(collection.designs).map((design)=>[
                        design.key,
                        {
                            swatchName: design.name,
                            color: isHexColor(design.swatch) ? design.swatch : '#ffffff'
                        }
                    ]));
            }
            return {};
        }),
        $selectedCollection: (self)=>self.$collectionMap[self.collection] ?? DEFAULT_COLLECTION,
        $selectedDesign: (self)=>self.$collectionMap[self.collection]?.designs[self.design] ?? DEFAULT_DESIGN
    },
    Drawstring: {
        $selectedColor: (self)=>self.$availableColors.find((c)=>c.key === self.color) ?? DEFAULT_DESIGN,
        $colorSwatches: memoEval((self)=>[
                self.$availableColors
            ], (availableColors)=>{
            return Object.fromEntries(availableColors.filter((color)=>AVAILABLE_DRAWSTRING_COLOR_KEYS.has(color.key)).map((color)=>[
                    color.key,
                    {
                        swatchName: color.name,
                        color: color.swatch
                    }
                ]));
        })
    }
});

//# sourceMappingURL=sidebar.js.map